import {
  FETCH_DEGREE_PLANNING_SETTINGS,
  FETCH_DEGREE_PLANNING_SETTINGS_SUCCESS,
  FETCH_DEGREE_PLANNING_SETTINGS_ERROR,
  UPDATE_DEGREE_PLANNING_SETTINGS,
  UPDATE_DEGREE_PLANNING_SETTINGS_SUCCESS,
  UPDATE_DEGREE_PLANNING_SETTINGS_ERROR,
} from './types';

const initialState = {
  settings: null,
  loading: false,
  error: false,
  saving: false,
};

const degreePlanningSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEGREE_PLANNING_SETTINGS:
      return { ...state, loading: true, error: false };
    case FETCH_DEGREE_PLANNING_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload };
    case FETCH_DEGREE_PLANNING_SETTINGS_ERROR:
      return { ...state, loading: false, error: true };
    case UPDATE_DEGREE_PLANNING_SETTINGS:
      return { ...state, saving: true };
    case UPDATE_DEGREE_PLANNING_SETTINGS_SUCCESS:
      return { ...state, saving: false, settings: action.payload };
    case UPDATE_DEGREE_PLANNING_SETTINGS_ERROR:
      return { ...state, saving: false };
    default:
      return state;
  }
};

export default degreePlanningSettingsReducer;
